// extracted by mini-css-extract-plugin
export default {"mainDiv":"NotFound_mainDiv__2GPu5","notFoundImage":"NotFound_notFoundImage__cM4+e"};